@if (type === 'primario') {
  <button
    class="primario"
    *ngIf="viewButton(text)"
    [style.width]="width"
    [style.color]="color"
    [style.backgroundColor]="bgColor"
    [style.border]="border"
    [disabled]="disabled"
    [type]="buttonType">
    <img [src]="icon" class="icon-photo" />
    {{ text }}
  </button>
}
@if (type === 'secundario') {
  <button
    class="secundario"
    *ngIf="viewButton(text)"
    [style.width]="width"
    [style.color]="color"
    [style.backgroundColor]="bgColor"
    [style.border]="border"
    [disabled]="disabled"
    [type]="buttonType">
    <img [src]="icon" class="icon-photo" />
    {{ text }}
  </button>
}
@if (type === 'cadastro') {
  <button
    class="cadastro"
    *ngIf="viewButton(text)"
    [style.width]="width"
    [style.color]="color"
    [style.backgroundColor]="bgColor"
    [style.border]="border"
    [disabled]="disabled"
    [type]="buttonType">
    <img [src]="icon" class="icon-photo" />
    {{ text }}
  </button>
}

@if (type === 'upload') {
  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileSelected($event)"
    accept=".pdf" />
  <button
    class="secundario"
    [style.width]="width"
    [style.color]="color"
    [style.backgroundColor]="bgColor"
    [style.border]="border"
    [disabled]="disabled"
    [type]="buttonType"
    (click)="fileInput.click()">
    <img [src]="icon" class="icon-photo" />
    {{ text }}
  </button>
}
